<template>
  <div v-if="!closed" class="apologize">
    現在、一時的に推定混雑状況の更新が遅れております。[<a
      href="#"
      @click.prevent="closed = true"
      >閉じる</a
    >]
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Apologize',
  data: function () {
    return {
      closed: true // 障害発生時 falseにする
    };
  }
});
</script>

<style scoped lang="scss">
.apologize {
  height: 40px;
  line-height: 40px;
  text-align: center;
  background-color: #e4e9ef;

  &,
  a {
    color: #000;
    font-size: 15px;
    font-weight: bold;
  }
}

@media screen and (max-width: 394px) {
  .apologize {
    &,
    a {
      font-size: 8px;
    }
  }
}

@media screen and (min-width: 395px) and (max-width: 509px) {
  .apologize {
    &,
    a {
      font-size: 10px;
    }
  }
}

@media screen and (min-width: 510px) and (max-width: 599px) {
  .apologize {
    &,
    a {
      font-size: 13px;
    }
  }
}
</style>
